// ESPHome-Geraeteliste fuer /zuhause/integrationen/esphome. Backend pollt
// die ESPHome-API der Geräte + filtert disabled-Entities. Die Daten liest nur
// die Navigationssuche (lib/inventory-index.svelte.ts): start* holt sie
// EINMAL (die Namen für Suche und Embedding-Index), danach Takt 30 s nur
// solange die Suche offen ist (beobachteEsphome, lib/bei-bedarf.ts).

import { untrack } from "svelte";
import { SvelteMap } from "svelte/reactivity";
import { beiBedarf } from "./bei-bedarf";
import { registerRevalidator } from "./revalidate.svelte";

import { loadPersisted, persist } from "./persistent-summary.svelte";

export interface EsphomeDevice {
  id: string;
  category: string;
  online: boolean;
  last_seen: string;
  status_text: string;
}

const STORAGE_KEY = "esphome";

const _state = new SvelteMap<string, EsphomeDevice[]>();
let _started = false;

async function refresh(): Promise<void> {
  try {
    const r = await fetch("/v2-api/esphome/devices", { credentials: "include" });
    if (!r.ok) return;
    const list = (await r.json()) as EsphomeDevice[];
    _state.set("current", list);
    persist(STORAGE_KEY, list);
  } catch {
    // ignore
  }
}

// frisch: die Navigationssuche wird beim Tippen und Leeren der Palette neu gebaut
// (beobachteInventar) -- ein Abruf, der jünger als 30 s ist, genügt.
const _bedarf = beiBedarf({ hole: refresh, takt: 30_000, frisch: 30_000 });

export function startEsphomeSummary(): void {
  if (_started) return;
  _started = true;
  registerRevalidator(() => {
    if (_bedarf.aktiv()) void refresh();
  });
  const cached = loadPersisted<EsphomeDevice[]>(STORAGE_KEY);
  if (cached) _state.set("current", cached);
  void refresh();
}

// Anmelden, solange die Suche die Geräte zeigt; der Rückgabewert meldet ab.
export function beobachteEsphome(): () => void {
  return untrack(() => {
    startEsphomeSummary();
    return _bedarf.beobachte();
  });
}

export function stopEsphomeSummary(): void {
  _started = false;
  _bedarf.beende();
  _state.clear();
}

export function getEsphomeSummary(): EsphomeDevice[] | undefined {
  return _state.get("current");
}

export async function refreshEsphomeSummary(): Promise<void> {
  await refresh();
}
